import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { useId } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { formatCount } from '@/lib/numbers';

import { ACTIVITY, type DashboardData } from './dashboardData';

interface CurrentActivityCardProps {
  /** Absent while loading. */
  activity?: DashboardData['activity'];
}

/**
 * What is live right now, each count a link to the section that manages it.
 *
 * The sections are placeholders today, so the links go where the work will
 * be rather than nowhere.
 */
export function CurrentActivityCard({ activity }: CurrentActivityCardProps) {
  const headingId = useId();

  return (
    <Paper
      variant="outlined"
      component="section"
      aria-labelledby={headingId}
      sx={{ p: 2, minWidth: 0 }}
    >
      <Typography id={headingId} variant="h6" component="h2" sx={{ fontWeight: 600 }}>
        Current Activity
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Published and scheduled work
      </Typography>

      <List sx={{ mt: 1 }}>
        {ACTIVITY.map((entry) => (
          <ListItem key={entry.id} disablePadding>
            <ListItemButton component={RouterLink} to={entry.to} sx={{ borderRadius: 1 }}>
              <ListItemText primary={entry.label} />
              <Typography
                component="span"
                sx={{ fontWeight: 600, minWidth: 40, textAlign: 'right' }}
              >
                {/* A placeholder the width of a count, so the row keeps its
                    size and no number is claimed before it is known. */}
                {activity ? (
                  formatCount(activity[entry.id])
                ) : (
                  <Skeleton width={32} sx={{ ml: 'auto' }} />
                )}
              </Typography>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
